var React = require('react');

function Flogo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#fff","d":"M54.8,0H3.2A3.2,3.2,0,0,0,0,3.2V54.8A3.2,3.2,0,0,0,3.2,58H31V35.57H23.45V26.79H31V20.33c0-7.49,4.58-11.57,11.26-11.57A64.2,64.2,0,0,1,49,9.1v7.83h-4.6c-3.64,0-4.35,1.72-4.35,4.26v5.59h8.7l-1.13,8.78H40V58H54.8A3.2,3.2,0,0,0,58,54.8V3.2A3.2,3.2,0,0,0,54.8,0Z","key":0}),React.createElement("path",{"id":"f","fill":"#4267b2","d":"M40,58V35.57h7.57l1.13-8.78H40V21.2c0-2.54.71-4.26,4.35-4.26H49V9.1a64.2,64.2,0,0,0-6.75-.34C35.56,8.76,31,12.84,31,20.33v6.46H23.45v8.78H31V58Z","key":1})]);
}

Flogo.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 58 58"};

module.exports = Flogo;

Flogo.default = Flogo;
